// \src\store\index.ts
import { createStore } from 'vuex';

export default createStore({
  state: {
    isAdjustByUtilization: false,
  },
  getters: {
    getIsAdjustByUtilization: (state) => state.isAdjustByUtilization,
  },
  mutations: {
    setIsAdjustByUtilization(state, value: boolean) {
      state.isAdjustByUtilization = value;
    },
  },
  actions: {
    updateIsAdjustByUtilization({ commit }, value: boolean) {
      commit('setIsAdjustByUtilization', value);
    },
  },
  modules: {},
});
